import { render, staticRenderFns } from "./menuDesign.vue?vue&type=template&id=ad853820&scoped=true"
import script from "./menuDesign.vue?vue&type=script&lang=js"
export * from "./menuDesign.vue?vue&type=script&lang=js"
import style0 from "./menuDesign.vue?vue&type=style&index=0&id=ad853820&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad853820",
  null
  
)

export default component.exports